jQuery(document).ready(function() {
  function preloadImage(url) {
    var img = new Image();
    img.src = url;
  }

  preloadImage("./wp-content/themes/lookeen/img/download/download-icon.svg");

  var $idown; // Keep it outside of the function, so it's initialized once.
  function downloadURL(url, vers) {
    //var url = "https://lookeen.de/wp-content/themes/lookeen/lookeen-downloads/lookeen-grab-dl-link.php?dl";
    var url = window.location.origin + "/wp-content/themes/da-theme/lookeen-downloads/lookeen-grab-dl-link.php?dl";

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      jQuery("#download-frame").remove();
    } else {
      if ($idown) {
        $idown.attr("src", url);
      } else {
        // $idown = jQuery("<iframe>", { id: "idown", src: url })
        //   .hide()
        //   .appendTo("body");
        if (jQuery(window).width() > 1024) {
          setTimeout(function() {
            if (/chrome/i.test(navigator.userAgent)) {

              jQuery("body")
                .append(
                  '<div id="dd-container">' +
                    '<div class="imgcont"><img src="https://lookeen.de/wp-content/themes/lookeen/img/download/download-icon.svg" alt=""></div>' +
                    '<div class="dau-step"><span>1</span><p>' + lookeenJsTranslations.dlStringChrome1a +
                    vers + lookeenJsTranslations.dlStringChrome1b +
                    '</p></div>' +
                    '<div class="dau-step"><span>2</span><p>' + lookeenJsTranslations.dlStringChrome2  +'</p></div>' +
                    '<div class="dau-step"><span>3</span><p>' + lookeenJsTranslations.dlStringChrome3 +'</p></div>' +
                    '<a href="#" class="closedown">x</a>' +
                    "</div>"
                )
                .show();
              console.log("append");
              jQuery("#dd-container")
                .css("bottom", "10px")
                .css("left", "10px");
              $idown = jQuery("<iframe>", { id: "idown", src: url })
                .hide()
                .appendTo("body");
            }
            if (/firefox/i.test(navigator.userAgent)) {
              jQuery("body")
                .append(
                  '<div id="dd-container" style="width:300px;height:auto;">' +
                    '<div class="imgcont" style="width:300px;text-align:center;margin-bottom:1px;"><img src="https://lookeen.de/wp-content/themes/lookeen/img/download/download-icon.svg" style="-ms-transform: rotate(180deg);-webkit-transform: rotate(180deg);transform: rotate(180deg);" alt=""></div>' +
                    '<div class="dau-step" style="margin-bottom:1px;"><span>1</span><p>' + lookeenJsTranslations.dlStringFirefox1 +'</p></div>' +
                    '<div class="dau-step" style="margin-bottom:1px;"><span>2</span><p>' + lookeenJsTranslations.dlStringFirefox2a +
                    vers + lookeenJsTranslations.dlStringFirefox2b +
                    "</p></div>" +
                    '<div class="dau-step" style="margin-bottom:1px;"><span>3</span><p>' + lookeenJsTranslations.dlStringFirefox3 +'</p></div>' +
                    '<div class="dau-step" style="margin-bottom:1px;"><span>4</span><p>' + lookeenJsTranslations.dlStringFirefox4 + '</p></div>' +
                    '<a href="#" class="closedown" style="margin-top:0; margin-left:-25px;">x</a>' +
                    "</div>"
                )
                .show();
              jQuery("#dd-container")
                .css("top", "10px")
                .css("right", "10px");
              $idown = jQuery("<iframe>", { id: "idown", src: url })
                .hide()
                .appendTo("body");
            }
            if (/msie|trident|edge/i.test(navigator.userAgent)) {
              jQuery("body")
                .append(
                  '<div id="dd-container">' +
                    '<a href="#" class="closedown">x</a>' +
                    '<div class="dau-step"><span>1</span><p>' + lookeenJsTranslations.dlStringIE1 + '</p></div>' +
                    '<div class="dau-step"><span>2</span><p>' + lookeenJsTranslations.dlStringIE2 + '</p></div>' +
                    '<div class="imgcont"><img src="https://lookeen.de/wp-content/themes/lookeen/img/download/download-icon.svg" alt=""></div>' +
                    "</div>"
                )
                .show();
              jQuery("#dd-container")
                .css("bottom", "70px")
                .css("right", "50%")
                .css("margin-right", "-320px");
              $idown = jQuery("<iframe>", { id: "idown", src: url })
                .hide()
                .appendTo("body");
            }
            jQuery(".closedown").click(function(e) {
              e.preventDefault();
              jQuery("#dd-container").remove();
            });
          }, 500);
        }
      }
    }
  }

  jQuery.ajax({
    method: "GET",
    //url      : 'http://lookeen.net/download/download-nonfree-version.php',
    url:
      window.location.origin + "/wp-content/themes/da-theme/lookeen-downloads/lookeen-grab-dl-link.php",
    success: function(result) {
      var res = result.split("###");
      jQuery(".downloadversion").replaceWith(res[1]);
      jQuery(".downloadversion-link").replaceWith(
        '<a href="https://www.lookeen.net/download/Lookeen.' +
          res[1] +
          '.zip">Lookeen.' +
          res[1] +
          ".zip</a>"
      );
      jQuery(".downloadversion-link-exe").replaceWith(
        '<a class="extra-fett" href="https://www.lookeen.net/download/Lookeen.' +
          res[1] +
          '.exe">click here</a>'
      );
      jQuery(".downloadversion-link-exe-forbtn").attr(
        "href",
        "https://www.lookeen.net/download/Lookeen." + res[1] + ".exe"
      );

      jQuery("#download-link-noauto").attr("href", res[0]);

      // disable auto download

      // if (
      //   /download/i.test(window.location.pathname) ||
      //   /download-update.html/i.test(window.location.pathname) ||
      //   /descarga/i.test(window.location.pathname)
      // ) {
      //   downloadURL(res[0], res[1]);
      // }

      // adding href to download button .desktop__download-btn
      jQuery(".desktop__download-btn .wp-block-button__link").attr("href", res[0]);




    }
  });
});
